module.exports = __webpack_public_path__ + "media/2022/mariah-siner-cd1592ee.jpg";